import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
//import { Component, OnInit, ViewChild } from '@angular/core';
import { customfunctions, DataParam } from "../common/customfunctions";
import { GlobalConstants } from "../common/global-constants";
import * as ngswal from "sweetalert";
import { TransactionAPIModel } from "./transaction-model";
import { ApiMethod } from "../apimethods/api-method";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient, HttpXhrBackend } from "@angular/common/http";
import { ArticleinfoComponent } from "../articleinfo/articleinfo.component";
declare var $;

@Component({
  selector: "app-transaction",
  templateUrl: "./transaction.component.html",
  styleUrls: ["./transaction.component.css"]
})
/** Transaction component*/
export class TransactionComponent implements OnInit {
  modelItem = new TransactionAPIModel();

  public progress: number;
  public message: string;
  @Output() public onUploadFinished = new EventEmitter();

  @ViewChild("dataTable") table;
  public aMenuList = [];
  dataTable: any;
  dtOptions: any;

  showModal: boolean;
  showGeneralNotesModal: boolean;
  showHoldModal: boolean;
  showFileUpload: boolean;

  title: string;
  transId: string;
  articleNo: string;
  articleTitle: string;
  articleType: string;
  //Authors: string;
  author: string;
  authorEMail: string;
  copyright: string;
  copyrightYear: string;
  volume: string;
  issue: string;
  pubDate: string;
  ePubDate: string;
  notes: string;
  monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  fileToUpload: File = null;
  selectedFile: string;
  fileCount: number;
  filePath: any;
  dataSet: any;
  uploadTitle: string;
  status: string;
  processName: string;

  journalList: any;
  issueList: any;
  volumeList: any;
  parameterStatus: any;

  ngOnInit() {
    ApiMethod.getBaseUrl();
    this.progress = 0; this.message = "";

    this.route.queryParams
      .subscribe(params => {
        console.log(params); // { orderby: "price" }
        //this.orderby = params.orderby;
        console.log(params.type); // price
        this.parameterStatus = params.type;
      });
  }

  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <TransactionAPIModel>data["TransactionPage"];
        localStorage.aEID = 0;
        localStorage.articleId = 0;
        this.progress = 0; this.message = "";

        $(".select2").select2({ dropdownParent: '#divFileUpload' });

        $("#lstJournals").select2({
          placeholder: "Select Journal",
          allowClear: true, tags: true,
          dropdownParent: ".card-body"
        });
        $("#lstJournals").val([]).trigger("change");

        $("#lstVolume").select2({
          placeholder: "Select Volume",
          allowClear: true, tags: true,
          dropdownParent: ".card-body"
        });
        $("#lstVolume").val([]).trigger("change");

        $("#lstIssue").select2({
          placeholder: "Select Issue",
          allowClear: true, tags: true,
          dropdownParent: ".card-body"
        });
        $("#lstIssue").val([]).trigger("change");

        this.getJournalsList();

        this.getTransationList();
        customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  getTransationList() {
    $("#LoadingImage").show();

    var fromDate = $("#Txt_FromDate").val();
    var toDate = $("#Txt_ToDate").val();

    var stageName = "";
    if (this.parameterStatus == "prd") {
      stageName = "Pagination";
      fromDate = "";
    }
    else if (this.parameterStatus == "proof") {
      stageName = "AuthorProof";
      fromDate = "";
    }

    var transactionData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      FromDate: fromDate,
      ToDate: toDate,
      Journals: $("#lstJournals").val().toString(),
      Volume: $("#lstVolume option:selected").text(),
      Issue: $("#lstIssue option:selected").text(),
      Stage: stageName
    };

    ApiMethod.postMethod(this.modelItem.TransactionAPI, transactionData).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.dataSet = JSON.stringify(result.aitemList);
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let acolList = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 75);
        dataItem.modulename = 'TransactionModule';
        dataItem.infoPopupID = 'ID';
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  getFiltered() {
    this.getTransationList();
  }

  resetFilter() {
    customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");
    $("#lstJournals").val(0).change();
    $("#lstVolume").val(0).change();
    $("#lstIssue").val(0).change();
    this.getTransationList();
  }

  showDetails() {
    $("#LoadingImage").show();

    var transactionData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      TransId: localStorage.aEID
    };

    ApiMethod.postMethod(this.modelItem.TransactioDetailsAPI, transactionData).subscribe(
      result => {
        this.transId = localStorage.aEID;
        localStorage.articleId = result.transactionDetails.ID;

        ArticleinfoComponent.ArticleInfo(localStorage.articleId);
        this.showModal = true;

        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  hide() {
    this.showModal = false;
    $("#divFileUpload").hide();
    $("#file").val("");
  }

  dateFormat(dateL) {
    try {
      var currentDate = "";

      if (dateL != null) {
        var date = new Date(dateL);

        var day = date.getDate();
        var dayString = day > 9 ? day : '0' + day;
        currentDate = dayString + ' ' + this.monthNames[date.getMonth()] + ' ' + date.getFullYear(); //month_names[date.getMonth()]
      }
      return currentDate;
    } catch (e) {
      return "";
    }
  }

  download() {
    ApiMethod.Downloadfile(this.modelItem.DownloadTransactionFile + '/' + localStorage.aLoginID + '/' + localStorage.aEID);
  }

  start() {
    ngswal({
      title: "Start Transaction",
      text: "Do you want to start this transaction ?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Start!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnStartConfirm').trigger("click");
        } else {
          ngswal("Cancelled", "Your Click cancel!", "warning");
        }
      });
  }

  startConfirm() {
    $("#LoadingImage").show();

    var transactionData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      TransId: localStorage.aEID
    };
    ApiMethod.postMethod(this.modelItem.StartAPI, transactionData).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.hide();
        if (result.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Started !",
            text: result.statusMessage,
            showConfirmButton: false,
            timer: 1500
          });
          this.getTransationList();
        } else {
          ngswal("Failed !", result.statusMessage, "warning");
        }
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  showUpload() {
    $("#LoadingImage").show();
    var transactionData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      TransId: localStorage.aEID
    };

    ApiMethod.postMethod(this.modelItem.TransactioDetailsAPI, transactionData).subscribe(
      result => {
        $("#LoadingImage").hide();

        this.uploadTitle = result.transactionDetails.ArticleNo;
        this.status = result.transactionDetails.Status;
        this.processName = result.transactionDetails.ProcessName;
        localStorage.ArticleNo = result.transactionDetails.ArticleNo;
        localStorage.UploadApi = this.modelItem.UploadTransactionFile;
        $("#txt_Remarks").val("");

        if (result.transactionDetails.ProcessNextProcessID == null) {
          $("#fileSelection").hide();
          $("#btnComplete").hide();
        }
        else {
          $("#btnComplete").show();
          $("#fileSelection").show();
        }

        if (result.transactionDetails.PreviousProcessID == null)
          $("#btnCorrection").hide();
        else
          $("#btnCorrection").show();

        //var selectProcess = $('#divFileUpload').find('#ddlProcess');
        //selectProcess.html("");
        //var zProcessList = "";
        //zProcessList += '<option value="0" disabled selected>Select Process</option>';
        //$.each(result.articleProcessList, (e, process) => {
        //  zProcessList += '<option value="' + process.ID + '">' + process.ProcessName + '</option>';
        //});
        //selectProcess.html(zProcessList);

        this.fileToUpload = null;
        this.selectedFile = "";
        //$('#astric').hide();
        //$('#btnAddFile').show();
        $("#divFileUpload").show();

        $(".upload").html("");
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  public selectUploadFile = (files) => {
    if (files.length == 0) {
      return;
    }
    this.fileToUpload = <File>files[0];
    this.selectedFile = this.fileToUpload.name;
  }

  //checkNextProcess() {
  //  var processName = $("#ddlProcess option:selected").text();

  //  if (processName == "Hold") {
  //    this.fileToUpload = null;
  //    this.selectedFile = "";

  //    $('#btnAddFile').hide();
  //    $('#fileSelection').hide();
  //    $('#astric').show();
  //  }
  //  else {
  //    $('#btnAddFile').show();
  //    $('#fileSelection').show();
  //    $('#astric').hide();
  //  }
  //}

  submit() {
    if (this.fileToUpload != null) {
      this.submitFile(this.fileToUpload);
      this.fileToUpload = null;
      this.selectedFile = "";
    } else
      this.updateTransaction("Correction");

    $("#divCorrection").hide();
  }

  public uploadFile = (files) => {
    if (files.length == 0) {
      return false;
    }
    this.fileToUpload = null;
    this.selectedFile = "";

    this.fileToUpload = <File>files[0];
    this.selectedFile = this.fileToUpload.name;

    this.submitFile(this.fileToUpload);
    return true;
  }

  submitFile(fileUpload) {
    const formData = new FormData();

    formData.append("file", fileUpload, fileUpload.name);
    formData.append("ClientApiUrl", localStorage.UploadApi);
    formData.append("transId", localStorage.aEID);
    formData.append("loginId", localStorage.aLoginID);
    formData.append("publisherId", localStorage.aPubID);
    formData.append("remarks", $("#txt_Remarks").val());
    //formData.append("processId", $("#ddlProcess option:selected").val());
    //formData.append("processName", $("#ddlProcess option:selected").text());
    formData.append("articleNo", localStorage.ArticleNo);

    $("#LoadingImagePopup").show();
    let http = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest() }));

    http.post($("base")[0].href + "api/Endpoint/PostFileClient", formData).subscribe(
      (response: Response) => {
        let msgInfo = "Success"; let msgDetails = "";
        let result = $(response.headers);
        $.each(result, (e, val) => {
          if (val.key == "ErrorMessage") {
            msgInfo = "Warning";
            msgDetails = val.value.toString();
          }
          else if (val.key == "SuccessMessage") {
            msgInfo = "Success";
            msgDetails = val.value.toString();
          }
        });
        ngswal({
          position: "top-end",
          type: msgInfo.toLowerCase(),
          title: "<i>" + msgInfo + "</i>",
          text: msgDetails,
          showConfirmButton: false,
          timer: 1500,
          html: true
        });
        this.getTransationList();
        this.hide();
        $("#LoadingImagePopup").hide();
      },
      (error) => {
        console.log(error.message);    // Show error, if any.
        ngswal("Warning !", error.message, "warning");
        $("#LoadingImagePopup").hide();
      }
    );
  }

  updateTransaction(process) {
    var transactionData = {
      Remarks: $("#txt_Remarks").val(),
      //NextProcessID: $("#ddlProcess option:selected").val(),
      ProcessName: process,

      TransId: localStorage.aEID,
      LoginId: localStorage.aLoginID
    };

    $("#LoadingImagePopup").show();
    ApiMethod.postMethod(this.modelItem.UpdateTransactionAPI, transactionData).subscribe(
      response => {
        $("#LoadingImagePopup").hide();
        if (response.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: response.message,
            showConfirmButton: false,
            timer: 2000
          });
          $("#divFileUpload").hide();
          this.getTransationList();
        } else {
          ngswal("Failed !", "Please try again later", "error");
        }
      }, error => {
        $("#LoadingImagePopup").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  correctionTransaction() {
    $("#divFileUpload").hide();

    $("#divCorrection").show();
  }

  holdTransaction() {
    if ($("#txt_Remarks").val() == "") {
      ngswal("Failed !", "Enter Remarks!", "warning");
      return false;
    }
    else
      this.updateTransaction("Hold");
    return true;
  }

  hideTransaction() {
    $("#divCorrection").hide();

    this.fileToUpload = null;
    this.selectedFile = "";
  }

  getJournalsList() {
    ApiMethod.getMethod(this.modelItem.GetJournalList + "/" + localStorage.aPubID + "/" + localStorage.aLoginID).subscribe(
      result => {
        this.journalList = result.aitemJournalList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  getVolumeIssue() {
    var journals = $("#lstJournals").val().toString();

    ApiMethod.getMethod(this.modelItem.VolumeIssueListAPI + "/" + journals).subscribe(
      result => {
        this.volumeList = result.volumeList;
        this.issueList = result.issueList;

        $("#lstIssue").val("0");
        $("#lstIssue").trigger("change");

        $("#lstVolume").val("0");
        $("#lstVolume").trigger("change");
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }
}
